import React, { useEffect, useState } from 'react'
import dropdown from '../../Images/Vector (8).png'
import HomeService from '../../Services/HomeService';
import { useNavigate } from 'react-router-dom';
const PreferedCity = () => {
    const [userData, setUserData] = useState()
    const [filterData, setFilterData] = useState({
        city: "",
        locality: "",
        propertyType: ""
    })

    const [localities, setLocalities] = useState([]);
    const fetchLocality = async (id) => {

        console.log("SWE15", id);
        try {
            // const res = await HomeService.getLocalitiesByCity(id);
            const res = await HomeService.getLocalitiesByCityWithoutAuth(id);
            console.log("KJH20",res,id);
            
            

            if (res?.status) {
                setLocalities(res?.data);
            }
        } catch (error) {
            console.error("Error fetching property types:", error);
        }
    };

    const [propertyType, setPropertyType] = useState([]);
    const fetchPropertyType = async () => {
        try {
            const res = await HomeService.getPropertyTypesWithoutAuth();
            console.log("ACV36",res);
            
            if (res?.status) {
                setPropertyType(res.data);
            }
        } catch (error) {
            console.error("Error fetching property types:", error);
        }
    };

    const getLoginProfile = async () => {
        const res = await HomeService.getLoginProfile();
        console.log("YTR170", res);

        if (res?.status) {
            console.log("AAZ9", res?.data);
            setUserData(res?.data)
            //   fetchLocality(res?.data?.city)
            //   fetchAllProperty(res?.data?._id,res?.data?.city)
        }
    };

    const [cities, setCities] = useState([])
    const fetchCity = async () => {
        try {
            const res = await HomeService.getAllCityList();
            console.log("FGH56", res);

            if (res?.status) {
                setCities(res.data);
            }
        } catch (error) {
            console.error("Error fetching city:", error);
        }
    };



    const navigate = useNavigate()
    const handleSearch = (e) => {
        e.preventDefault()
        navigate("/propertylist", { state: { data: filterData } })
    }

    useEffect(() => {
        filterData.city ? fetchLocality(filterData?.city) : setLocalities([])
    }, [filterData.city])

    useEffect(() => {
        getLoginProfile()
        fetchCity()
        fetchPropertyType()
    }, [])
    return (
        <>
            <div className='prefered_city_div'>
                <div className='prefered_city_form_wrapper'>
                    <h1 className='prefered_cities_head'>Find Your Property in Your Preferred City </h1>
                    <form>
                        <div className='form_fields_wrapper'>
                            <div className='form_filed'>
                                <label className='form_label'>City</label>

                                <select
                                    name="cityId"
                                    id="cityId"
                                    value={filterData?.city || ""}
                                    className="filter_input"
                                    onChange={(e) => {
                                        setFilterData((prevData) => ({
                                            ...prevData,
                                            city: e.target.value,
                                        }));
                                    }}
                                >
                                    <option value="">Select City</option>
                                    {
                                        // userData?.multiSubscribedCities
                                        cities
                                            // .filter(item => item?.isSubscribedByUser)
                                            .map((type) => (
                                                <option key={type?._id} value={type?._id}>
                                                    {type?.name}
                                                </option>
                                            ))}
                                </select>
                            </div>

                            <div className='form_filed'>
                                <label className='form_label'>Property Type</label>

                                <select
                                    name="propertyType"
                                    id="propertyType"
                                    value={filterData?.propertyType || ""}
                                    className="filter_input"
                                    onChange={(e) => {
                                        setFilterData((prevData) => ({
                                            ...prevData,
                                            propertyType: e.target.value,
                                        }));
                                    }}
                                >
                                    <option value="">Select Property Type</option>
                                    {propertyType.map((type) => (
                                        <option key={type._id} value={type._id}
                                            // disabled={type.isSubscribedByUser ? false : true}
                                        >
                                            {/* {type.isSubscribed ? "🔒 " : "🔒 "} */}
                                            {type.propertyType}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='form_filed'>
                                <label className='form_label'>Locality</label>

                                <select
                                    name="locality"
                                    id="locality"
                                    value={filterData?.locality || ""}
                                    className="filter_input"
                                    onChange={(e) => {
                                        setFilterData((prevData) => ({
                                            ...prevData,
                                            locality: e.target.value,
                                        }));
                                    }}
                                >
                                    <option value="">Select Locality</option>
                                    {localities.map((type) => (
                                        <option key={type?._id} value={type?._id}
                                            // disabled={type.isSubscribedByUser ? false : true}
                                        >
                                            {type?.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button onClick={(e) => handleSearch(e)} className='search_property_btn'>Search Property</button>


                        </div>
                    </form>

                </div>

            </div>
        </>
    )
}

export default PreferedCity
